import { TOP_BAR_CLASS } from '../../constants';
import { getMessages } from '../../../../../../store/constants';

export const CLASS_TOP_BAR_CHAT_VIEW = TOP_BAR_CLASS + '-chat-view';
export const CHAT_VIEW_TITLE = getMessages().getText('chat-view.title');
